module.exports = __webpack_public_path__ + "img/switch_power.b899caaa.png";